<template>
  <NuxtPage />
</template>
<script lang="ts" setup>
import useSystemStore from '~~/store/system'

const systemStore = useSystemStore()
</script>
<style lang="less">
// 前进
.forward-leave-active {
  transition: left 0.2s;
}
.forward-enter-active {
  transition: left 0.3s;
  position: fixed;
  width: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10000;
  background: @white;
}
.forward-enter-from {
  left: 100%;
}
.forward-enter-to {
  left: 0;
}
// 后退
.backward-leave-active {
  transition: left 0.2s;
  position: fixed;
  width: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10000;
  background: @white;
}
.backward-enter-active {
  transition: left 0.1s;
}
.backward-leave-from {
  left: 0;
}
.backward-leave-to {
  left: 100%;
}
</style>
